import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { connectionEstablished, connectionLost, messageReceived, connectionError } from '../store/websocketSlice';

const useWebSocket = (url) => {
  const [isConnected, setIsConnected] = useState(false);
  const ws = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const connect = () => {
      ws.current = new WebSocket(url);

      ws.current.onopen = () => {
        setIsConnected(true);
        dispatch(connectionEstablished());
      };

      ws.current.onmessage = (event) => {
        const message = JSON.parse(event.data);
        dispatch(messageReceived(message));
      };

      ws.current.onclose = () => {
        setIsConnected(false);
        dispatch(connectionLost());
        setTimeout(() => connect(), 5000); // Reconnect after 5 seconds
      };

      ws.current.onerror = (error) => {
        console.error('WebSocket error:', error);
        dispatch(connectionError(error));
      };
    };

    connect();

    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, [url, dispatch]);

  const sendMessage = (message) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    }
  };

  return { isConnected, sendMessage };
};

export { useWebSocket };
